import '../../scss/pages/static-page.scss';
import 'swiper/dist/css/swiper.css';
import '../../scss/pages/about-us.scss';

import Swiper from 'swiper';

const Carousels = {
    productsSlider: null,

    init() {
        const productsSlider = '.hobby-products-slider.swiper-container';
        Carousels.productsSlider = new Swiper(productsSlider, {
            slidesPerView: 'auto',
            spaceBetween: 46,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: true,
            },
            breakpoints: {
                768: {
                    spaceBetween: 25
                },
            }
        });
        const productsSliderItems = document.querySelectorAll(productsSlider + ' .swiper-slide');
    }
};

function initialize() {
    Carousels.init();
}

initialize();
